import { FC } from "react";
import {
  ButtonBox,
  InputDatePicker,
  SelectBox,
  TextBox,
  PrivilegesChecker,
} from "..";
import {
  InputDatePickerTimeDisplayModeEnum,
  LookupItemModel,
  PageEnum,
  TransactionDueDateSearchParamsModel,
} from "../../models";
import { getLabelName } from "../../utils";

interface SearchTransactionDueDateFieldsProps {
  searchParams: TransactionDueDateSearchParamsModel;
  onUpdateSearchParam: (
    key: keyof TransactionDueDateSearchParamsModel,
    value: any
  ) => void;
  onSearch: () => void;
  onReset: () => void;
  customerList: LookupItemModel[];
  loading: boolean;
}

export const SearchTransactionDueDateFields: FC<
  SearchTransactionDueDateFieldsProps
> = ({
  searchParams,
  onUpdateSearchParam,
  onSearch,
  onReset,
  customerList,
  loading,
}) => {
  return (
    <div className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-md-4 g-sm-4 mb-1 align-items-center mb-3">
      <InputDatePicker
        selectedDate={searchParams.fromDate}
        isClearable
        InputLabel={getLabelName("From Date")}
        selectsEnd
        timeMode={InputDatePickerTimeDisplayModeEnum.TimeSelect}
        className="form-control"
        endDate={searchParams.toDate}
        onChange={(date) =>
          onUpdateSearchParam("fromDate", date === null ? undefined : date)
        }
      />

      <InputDatePicker
        selectedDate={searchParams.toDate}
        isClearable
        InputLabel={getLabelName("To Date")}
        selectsEnd
        timeMode={InputDatePickerTimeDisplayModeEnum.TimeSelect}
        startDate={searchParams.fromDate}
        className="form-control"
        minDate={searchParams.fromDate}
        onChange={(date) =>
          onUpdateSearchParam("toDate", date === null ? undefined : date)
        }
      />

      <SelectBox
        labelName={getLabelName("Customer")}
        isSingleSelect={true}
        selectedValues={
          searchParams.customerId ? [searchParams.customerId.toString()] : null
        }
        source={customerList}
        onStatusChange={(e: LookupItemModel) =>
          onUpdateSearchParam(
            "customerId",
            e?.value ? Number(e.value) : undefined
          )
        }
      />

      <TextBox
        labelName={getLabelName("chkTransactionNo")}
        inputName={"transactionIdTextBox"}
        inputValue={searchParams.transactionId?.toString() || ""}
        onChange={(e: any) => {
          const value = e.target.value ? Number(e.target.value) : undefined;
          onUpdateSearchParam("transactionId", value);
        }}
      />

      <SelectBox
        labelName={getLabelName("Payment Type")}
        isSingleSelect={true}
        selectedValues={
          searchParams.isPaid ? [searchParams.isPaid.toString()] : undefined
        }
        source={[
          {
            name: getLabelName("IsPaid"),
            nameAr: getLabelName("IsPaid"),
            value: "true",
          },
          {
            name: getLabelName("Unpaid"),
            nameAr: getLabelName("Unpaid"),
            value: "false",
          },
          {
            name: getLabelName("All"),
            nameAr: getLabelName("All"),
            value: null,
          },
        ]}
        onStatusChange={(e: LookupItemModel) =>
          onUpdateSearchParam(
            "isPaid",
            e?.value === "true"
              ? true
              : e?.value === "false"
              ? false
              : undefined
          )
        }
      />

      <div className="col-md-4 d-flex justify-content-end align-items-center">
        <PrivilegesChecker
          formId={PageEnum.ManageTransactionDueDate}
          action="EnableSearch"
        >
          <ButtonBox
            iconType="account-search"
            className="btn btn-primary btn-md mx-2 mb-2"
            onClick={onSearch}
            disabled={loading}
          >
            {getLabelName("Search")}
          </ButtonBox>
        </PrivilegesChecker>

        <ButtonBox
          iconType="receipt"
          variant="danger"
          className="btn btn-danger btn-md mb-2"
          onClick={onReset}
          disabled={loading}
        >
          {getLabelName("Reset")}
        </ButtonBox>
      </div>
    </div>
  );
};
